import { ClientEvents } from 'common/events/ClientEvents';
import React, { useMemo } from 'react';
import { useTracker } from 'src/shared/hooks/useTracker';
import { AVAILABLE_DIETARY_OPTIONS, HIDDEN_DIETARY_TAGS } from 'src/shared/utils/diet-utils';
import { DietaryTags } from 'web-common/src/shared/Enums';
import { FilterSelectorWrapper } from '../styles';
import { DietaryFilterButton } from './DietaryFilterButton';
import { DietaryFilterSelector } from './DietaryFilterSelector';

interface IProps {
  isOpen: boolean;
  selectedDietaryFilters: DietaryTags[];
  onChange: (values: { dietaryTags?: DietaryTags[] }) => void;
  onOpen: () => void;
  className?: string;
}
export const DietaryFilter: React.FC<IProps> = ({ isOpen, selectedDietaryFilters, onOpen, onChange, className }) => {
  const regularDietaryFilters = useMemo(
    () => selectedDietaryFilters.filter((dietaryTag) => !HIDDEN_DIETARY_TAGS.includes(dietaryTag)),
    [selectedDietaryFilters]
  );

  const tracker = useTracker();

  const onClick = () => {
    const isOpening = !isOpen;
    if (isOpening) {
      tracker.track(ClientEvents.CLICK_DIETARY_FILTER, {});
    }
    return onOpen();
  };

  return (
    <FilterSelectorWrapper data-cy='dietary-filter-button' className={className}>
      <DietaryFilterButton activeDietaryTags={regularDietaryFilters} onClick={onClick} />
      {isOpen && (
        <DietaryFilterSelector
          dietaryOptions={AVAILABLE_DIETARY_OPTIONS}
          activeDietaryTags={regularDietaryFilters}
          onSubmit={onChange}
        />
      )}
    </FilterSelectorWrapper>
  );
};
